import React from 'react';

const AboutPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      {/* Hero */}
      <div className="mb-12">
        <h1 className="text-4xl font-bold text-slate-800 mb-4" style={{ fontFamily: "'Fairplay Display', Georgia, serif" }}>
          About Chrysalinks Group
        </h1>
        <p className="text-lg text-slate-600 leading-relaxed">
          We exist to make professional digital presence accessible to every lifestyle entrepreneur in South Africa.
        </p>
      </div>

      {/* Mission */}
      <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-slate-100">
        <h2 className="text-2xl font-bold text-slate-800 mb-4" style={{ fontFamily: "'Fairplay Display', Georgia, serif" }}>
          Our Mission
        </h2>
        <p className="text-slate-600 leading-relaxed">
          Too many small business owners go without a professional website because of cost, complexity, or lack of time.
          Chrysalinks Group removes those barriers. We give you a free website when you refer 5 friends, proving our value first.
          Then, when you're ready to grow, the BizBuilder Platform gives you the tools to scale.
        </p>
      </div>

      {/* How It Works */}
      <div className="grid md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-slate-100 text-center">
          <div className="w-16 h-16 bg-[#4a6580]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">🎁</span>
          </div>
          <h3 className="font-bold text-slate-800 mb-2">Step 1: Refer 5</h3>
          <p className="text-sm text-slate-600">Refer 5 friends who register for their free 1-pager website.</p>
        </div>
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-slate-100 text-center">
          <div className="w-16 h-16 bg-[#6e5c25]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">🌐</span>
          </div>
          <h3 className="font-bold text-slate-800 mb-2">Step 2: Get Your Site</h3>
          <p className="text-sm text-slate-600">We build and deploy your professional 1-pager website — free.</p>
        </div>
        <div className="bg-white rounded-2xl shadow-lg p-6 border border-slate-100 text-center">
          <div className="w-16 h-16 bg-[#b89b2e]/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">📈</span>
          </div>
          <h3 className="font-bold text-slate-800 mb-2">Step 3: Grow</h3>
          <p className="text-sm text-slate-600">Upgrade to Network Membership or become a partner to earn.</p>
        </div>
      </div>

      {/* Values */}
      <div className="bg-white rounded-2xl shadow-lg p-8 border border-slate-100">
        <h2 className="text-2xl font-bold text-slate-800 mb-6" style={{ fontFamily: "'Fairplay Display', Georgia, serif" }}>
          Our Values
        </h2>
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h3 className="font-bold text-[#4a6580] mb-2">Prove Value First</h3>
            <p className="text-sm text-slate-600">We deliver real results before asking for commitment.</p>
          </div>
          <div>
            <h3 className="font-bold text-[#6e5c25] mb-2">Empower Entrepreneurs</h3>
            <p className="text-sm text-slate-600">Every tool we build helps business owners take control of their growth.</p>
          </div>
          <div>
            <h3 className="font-bold text-[#b89b2e] mb-2">Community Over Competition</h3>
            <p className="text-sm text-slate-600">Referrals and partnerships create shared success.</p>
          </div>
          <div>
            <h3 className="font-bold text-slate-800 mb-2">Simplicity by Design</h3>
            <p className="text-sm text-slate-600">Powerful tools that are easy to use — no complexity, no fluff.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
